import { Action } from 'redux'
import { IFilterRoomsValues } from '../../../containers/Form/FilterRooms/withReduxForm'
import { CalendarFiltersActions } from '../../../reducers/bookingCalendar/actionNames'

export const applyFiltersDrawer = (
  filters: IFilterRoomsValues,
): IApplyFiltersDrawer => ({
  filters,
  type: CalendarFiltersActions.ApplyFilters,
})

export const clearFiltersDrawer = (): ICleanFiltersDrawer => ({
  type: CalendarFiltersActions.CleanFilters,
})

export interface IApplyFiltersDrawer
  extends Action<CalendarFiltersActions.ApplyFilters> {
  filters: IFilterRoomsValues
}

export type ICleanFiltersDrawer = Action<CalendarFiltersActions.CleanFilters>
